// React-snapshot & Mapbox fix – https://github.com/geelen/react-snapshot/pull/34
if (window && window.URL && !window.URL.createObjectURL) {
  window.URL.createObjectURL = () => {}
}



// WEBPACK FOOTER //
// ./src/utils/polyfill.js